import { axiosAction } from "../../utils/axiosAction";
import { UNITS_OF_MEASURES_FETCH } from "../action-types/units-of-measures-types";

const ENDPOINT_FETCH = `${process.env.REACT_APP_ENDPOINT_UNIT_OF_MEASURES}`;

export const getEntities = () => async dispatch => {
  const endpoint = `${ENDPOINT_FETCH}`;
  return axiosAction.get(endpoint, UNITS_OF_MEASURES_FETCH, dispatch);
};
